import { render, staticRenderFns } from "./UsageReview.vue?vue&type=template&id=484903ff"
import script from "./UsageReview.vue?vue&type=script&lang=js"
export * from "./UsageReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports